/**********************************************************************************************************************/
/* FILE: hafas_webapp_subscription_journeycourse.js                                                                           */
/**********************************************************************************************************************/
/* Subscriptions Custom */
HafasWebapp.prototype.subscriptions.JourneyCourse = function (_me) {
  Hafas.ps.sub('/JourneyCourse/open', Hafas.bind(_me.Controller.JourneyCourse.openJourneyCourse, _me));
  Hafas.ps.sub('/journeycourse/closeJourneyCourse', Hafas.bind(_me.Controller.JourneyCourse.closeJourneyCourse, _me));
  Hafas.ps.sub('/journeycourse/start/', Hafas.bind(_me.Controller.JourneyCourse.startJourneyCourse,_me));
  Hafas.ps.sub('/journeyCourse/addedNewJourney',Hafas.bind(_me.Controller.JourneyCourse.addLivemap,_me));
};

